import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import Edit from "@mui/icons-material/Edit";
import { IfPermission } from "../../auth/IfPermission";
import { UserHierarchy } from "../../auth/UserHierarchy";
import type { CurrentUserHierarchy } from "../../auth/UserHierarchy";
import type { UserListItem } from "./useUserList";
import { formatDateTime } from "./FormatDateTime";

interface UserDataGridProps {
  items: UserListItem[];
  current: CurrentUserHierarchy;
  onEdit: (user: UserListItem) => void;
}

export function UserDataGrid({ items, current, onEdit }: UserDataGridProps) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Логин</TableCell>
          <TableCell>Имя</TableCell>
          <TableCell>Роль</TableCell>
          <TableCell>Статус</TableCell>
          <TableCell>Последний вход</TableCell>
          <TableCell>Дата создания</TableCell>
          <TableCell align="right">Действия</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((user) => (
          <TableRow key={user.id}>
            <TableCell>{user.login}</TableCell>
            <TableCell>{user.name}</TableCell>
            <TableCell>{user.role.name}</TableCell>
            <TableCell>
              {user.status === "active" ? (
                <Chip label="Активен" size="small" color="success" />
              ) : (
                <Chip label="Деактивирован" size="small" variant="outlined" />
              )}
            </TableCell>
            <TableCell>{formatDateTime(user.lastLoginAt)}</TableCell>
            <TableCell>{formatDateTime(user.createdAt)}</TableCell>
            <TableCell align="right">
              {UserHierarchy.canManageUser(current, user) ? (
                <IfPermission permission="users.manage">
                  <Tooltip title="Редактировать">
                    <IconButton aria-label="Редактировать" onClick={() => onEdit(user)}>
                      <Edit />
                    </IconButton>
                  </Tooltip>
                </IfPermission>
              ) : null}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
